const { has } = require("ramda")
const { docs: lagosDocs } = require("./cities-data/lagos/docs")
const { docs: abujaDocs } = require("./cities-data/abuja/docs")
const { docs: ogunDocs } = require("./cities-data/ogun/docs")

const vehiclePapers = {
  defaultCity: lagosDocs(),
  abuja: abujaDocs(),
  lagos: lagosDocs(),
  ogun: ogunDocs(),
}
const vehicleKeys = (city = "defaultCity") => {
  const vCity = has(city)(vehiclePapers) ? city : "defaultCity"

  return vehiclePapers[vCity].reduce(
    (data, current) => {
      data[current.key] = current.name

      return data
    },
    { dl: "Driver's Licence", ci: "Comprehensive Insurance", vt: "Vehicle Tracking" }
  )
}

const notDeliveredDocs = (city = "defaultCity") => {
  const vCity = has(city)(vehiclePapers) ? city : "defaultCity"
  return vehiclePapers[vCity]
    .filter((doc) => doc?.meta?.notDelivered)
    .map((doc) => doc.key)
}

module.exports = { vehiclePapers, vehicleKeys, notDeliveredDocs }
